// extracted by mini-css-extract-plugin
module.exports = {"layout":"RegistrationLayoutFooter_layout__FKf24","mobileLayout":"RegistrationLayoutFooter_mobileLayout___yDMx"};